import React, { useState } from "react";
import {
    GoogleMap,
    useJsApiLoader,
    Polygon,
    Marker,
    DirectionsRenderer,
} from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "400px",
};

const center = {
    lat: 51.5072,
    lng: -0.1276,
};


function MapsComponent({
    origin,
    destination,
    setDirections,
    directions,
    setDistance,
    setDuration,
}) {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: "AIzaSyAAmk9262zy3r526FEW60VE41oklDRETWo",
    });
    const congestionZoneCoordinates = [
        { lng: -0.16741185153645688, lat: 51.51808707233778 },
        { lng: -0.16674528092835317, lat: 51.51764613363389 },
        { lng: -0.1655104628863171, lat: 51.51695997818658 },
        { lng: -0.16150481470316436, lat: 51.51423910401064 },
        { lng: -0.15989757950100625, lat: 51.51329595913248 },
        { lng: -0.15880443522274845, lat: 51.513433921813686 },
        { lng: -0.15823875216909755, lat: 51.513334017844954 },
        { lng: -0.1579024000838558, lat: 51.51273934683047 },
        { lng: -0.15691708341404365, lat: 51.51089702012172 },
        { lng: -0.1564813545753907, lat: 51.51023095243352 },
        { lng: -0.155411143393394, lat: 51.509545844080236 },
        { lng: -0.15420704002400498, lat: 51.50850490152999 },
        { lng: -0.15145793005541464, lat: 51.50607705029424 },
        { lng: -0.15093046882978456, lat: 51.505529866094776 },
        { lng: -0.15077717743415064, lat: 51.50501537318553 },
        { lng: -0.150952997842694, lat: 51.50415888809866 },
        { lng: -0.15095029998289533, lat: 51.503274251945186 },
        { lng: -0.1499335993597697, lat: 51.50328376871943 },
        { lng: -0.1497042683923837, lat: 51.50307915763699 },
        { lng: -0.14988773316630954, lat: 51.50242249260907 },
        { lng: -0.15101909927363977, lat: 51.50205132992926 },
        { lng: -0.151542323825538, lat: 51.50179601128312 },
        { lng: -0.15102250696537567, lat: 51.50149146358186 },
        { lng: -0.149722964897137, lat: 51.50066822303313 },
        { lng: -0.14895088397329914, lat: 51.50010193901187 },
        { lng: -0.14809148961074925, lat: 51.49940972582064 },
        { lng: -0.1469218987776344, lat: 51.49816766298278 },
        { lng: -0.14517898342415947, lat: 51.49827711802948 },
        { lng: -0.1442005046291115, lat: 51.49813910944914 },
        { lng: -0.14355837791930526, lat: 51.49798206469404 },
        { lng: -0.1431226490816755, lat: 51.49790592158794 },
        { lng: -0.1424193674475589, lat: 51.4977583939575 },
        { lng: -0.14206008226511813, lat: 51.49750140920318 },
        { lng: -0.14175430764151997, lat: 51.496849422862 },
        { lng: -0.141853684393908, lat: 51.49661622840256 },
        { lng: -0.14252057971231125, lat: 51.49641585980774 },
        { lng: -0.14250529098148945, lat: 51.496120794423774 },
        { lng: -0.1418784530035282, lat: 51.49521654989951 },
        { lng: -0.141404502336826, lat: 51.49467875385977 },
        { lng: -0.1407241537999937, lat: 51.49408859869166 },
        { lng: -0.140070712318078, lat: 51.493760972728325 },
        { lng: -0.1364743100851058, lat: 51.491988800864306 },
        { lng: -0.13265674710069675, lat: 51.49015069915751 },
        { lng: -0.12854106847439084, lat: 51.4882765917213 },
        { lng: -0.12501196553498062, lat: 51.48665988371741 },
        { lng: -0.12322337620261692, lat: 51.48626468077711 },
        { lng: -0.122232920819215, lat: 51.48620480124515 },
        { lng: -0.12065588506405334, lat: 51.48621677715798 },
        { lng: -0.11921347431183449, lat: 51.48641437926369 },
        { lng: -0.11642483294005501, lat: 51.48685747440442 },
        { lng: -0.11328999357260727, lat: 51.486971243819596 },
        { lng: -0.11271302927224269, lat: 51.48712692782274 },
        { lng: -0.11220337747334952, lat: 51.48741434304765 },
        { lng: -0.11174180603308059, lat: 51.487863425708866 },
        { lng: -0.11104945479107187, lat: 51.48870170046976 },
        { lng: -0.11059749942222652, lat: 51.48902503130276 },
        { lng: -0.11021285655490942, lat: 51.489198670988884 },
        { lng: -0.10817424935939357, lat: 51.489761498528935 },
        { lng: -0.10756843854213116, lat: 51.48999500907391 },
        { lng: -0.1060202510013255, lat: 51.49078534686447 },
        { lng: -0.10544328670096093, lat: 51.49092904317243 },
        { lng: -0.10307570312139092, lat: 51.491319478968165 },
        { lng: -0.10084477449160545, lat: 51.4929719398053 },
        { lng: -0.10055629234145158, lat: 51.493367084609616 },
        { lng: -0.10058095840784631, lat: 51.49377985226124 },
        { lng: -0.10068673519651838, lat: 51.49460604557527 },
        { lng: -0.10075404769798979, lat: 51.49480361132302 },
        { lng: -0.10112621731755667, lat: 51.49506282205712 },
        { lng: -0.1012319941061719, lat: 51.49524841228771 },
        { lng: -0.10115506553322007, lat: 51.495445975251755 },
        { lng: -0.1008858155259702, lat: 51.495541763047015 },
        { lng: -0.1004915565872011, lat: 51.49560163031714 },
        { lng: -0.10011652979127916, lat: 51.49556570996464 },
        { lng: -0.09989536014256828, lat: 51.495254399057046 },
        { lng: -0.09963572620807781, lat: 51.49509275601653 },
        { lng: -0.09837602081748287, lat: 51.4949191387789 },
        { lng: -0.09525078893150862, lat: 51.494218669596734 },
        { lng: -0.09414494068934687, lat: 51.4941109051849 },
        { lng: -0.08923112403772393, lat: 51.49420071066845 },
        { lng: -0.0864136150361503, lat: 51.49431446176038 },
        { lng: -0.0861347489573916, lat: 51.49481137109771 },
        { lng: -0.0858174185928533, lat: 51.494889199780175 },
        { lng: -0.08483376348186766, lat: 51.49472930760399 },
        { lng: -0.08364137059405152, lat: 51.49540581523624 },
        { lng: -0.08251629020770679, lat: 51.49630980533789 },
        { lng: -0.08212934167124786, lat: 51.49656268019342 },
        { lng: -0.07986956482574215, lat: 51.49755644443465 },
        { lng: -0.07810982462231664, lat: 51.50124881061012 },
        { lng: -0.07750401374357807, lat: 51.5023681723095 },
        { lng: -0.07838869233833634, lat: 51.5029667518092 },
        { lng: -0.07828291554972111, lat: 51.503008652079956 },
        { lng: -0.07715783516334795, lat: 51.502811121895576 },
        { lng: -0.07615775975554584, lat: 51.50434710268834 },
        { lng: -0.07430622368826789, lat: 51.50709414336606 },
        { lng: -0.07392868548092224, lat: 51.50888181670922 },
        { lng: -0.07375559619089245, lat: 51.509270838663554 },
        { lng: -0.0746787390727377, lat: 51.50998303948063 },
        { lng: -0.07497683729437199, lat: 51.510378036814814 },
        { lng: -0.07513069444155462, lat: 51.51095855698432 },
        { lng: -0.07507039902603196, lat: 51.5111463964283 },
        { lng: -0.07290678289774633, lat: 51.511230181888266 },
        { lng: -0.07305102397350538, lat: 51.51170296838106 },
        { lng: -0.07326302373172666, lat: 51.51315373015822 },
        { lng: -0.07349380945186113, lat: 51.513919729159085 },
        { lng: -0.0739265335235757, lat: 51.514470283619545 },
        { lng: -0.07183022989676147, lat: 51.51527814947025 },
        { lng: -0.07430806519795397, lat: 51.518246361136306 },
        { lng: -0.07446361250856626, lat: 51.51855007798483 },
        { lng: -0.07448284465149868, lat: 51.52010581563894 },
        { lng: -0.07456938929718149, lat: 51.52042294025546 },
        { lng: -0.07540861819026645, lat: 51.521222007692074 },
        { lng: -0.07709143073407176, lat: 51.522556276870944 },
        { lng: -0.07923654160853744, lat: 51.523731451196454 },
        { lng: -0.08035200592343017, lat: 51.52367760391445 },
        { lng: -0.08035200592343017, lat: 51.524353681836544 },
        { lng: -0.08096743451091015, lat: 51.524694708484475 },
        { lng: -0.08209251489722647, lat: 51.524688725582564 },
        { lng: -0.08196750596567881, lat: 51.52523914924245 },
        { lng: -0.08362146959936467, lat: 51.52610665141455 },
        { lng: -0.08446768390697912, lat: 51.52629211522432 },
        { lng: -0.08519850535449791, lat: 51.52623827097034 },
        { lng: -0.08686208429998032, lat: 51.525813496724226 },
        { lng: -0.08732365574024925, lat: 51.525251114352415 },
        { lng: -0.08820833433500752, lat: 51.525598117061946 },
        { lng: -0.08781407539621, lat: 51.52617246056343 },
        { lng: -0.08818910219082454, lat: 51.52690832758711 },
        { lng: -0.08850643255664181, lat: 51.52729719560179 },
        { lng: -0.08894877185400674, lat: 51.52750658469543 },
        { lng: -0.09139125795738323, lat: 51.528176624013355 },
        { lng: -0.10180547156693365, lat: 51.5308259192214 },
        { lng: -0.1024978287274223, lat: 51.52979698714799 },
        { lng: -0.10555573952058239, lat: 51.531783044458365 },
        { lng: -0.10625910709285336, lat: 51.531900872190164 },
        { lng: -0.10763420534357238, lat: 51.53184703456907 },
        { lng: -0.10978820539909862, lat: 51.53176328703185 },
        { lng: -0.11123061615131746, lat: 51.531601773489484 },
        { lng: -0.11289829767576975, lat: 51.53146732555547 },
        { lng: -0.11287906553155835, lat: 51.531066529031875 },
        { lng: -0.11446571735950783, lat: 51.530456354414866 },
        { lng: -0.11483112808261353, lat: 51.53061188989781 },
        { lng: -0.11574465966850767, lat: 51.529810278553754 },
        { lng: -0.11571581145287269, lat: 51.52942741428316 },
        { lng: -0.11825445437574444, lat: 51.52887105890167 },
        { lng: -0.11793712401120615, lat: 51.52839845060231 },
        { lng: -0.11865832938602239, lat: 51.52821897781067 },
        { lng: -0.11898527582332008, lat: 51.52872748221532 },
        { lng: -0.11949492762215641, lat: 51.52867364084136 },
        { lng: -0.12071616872566437, lat: 51.530175193064736 },
        { lng: -0.12107196337731807, lat: 51.530408497531 },
        { lng: -0.12173547232336546, lat: 51.53057001530692 },
        { lng: -0.12242782960046839, lat: 51.53067171157784 },
        { lng: -0.12747983389593287, lat: 51.52857458724577 },
        { lng: -0.13592378189039778, lat: 51.5255231376816 },
        { lng: -0.13495255865123568, lat: 51.52460177833166 },
        { lng: -0.13725079978249255, lat: 51.52372826458995 },
        { lng: -0.1376931390798859, lat: 51.524338529378895 },
        { lng: -0.13810663016158742, lat: 51.52504451177492 },
        { lng: -0.1405971927259202, lat: 51.52439835882021 },
        { lng: -0.14265503206556218, lat: 51.52394365309641 },
        { lng: -0.14331854008861455, lat: 51.523919721215464 },
        { lng: -0.1438955043889507, lat: 51.52350689213273 },
        { lng: -0.14423206689775725, lat: 51.52357270571525 },
        { lng: -0.14423206689775725, lat: 51.52402741514325 },
        { lng: -0.14466479012364175, lat: 51.52406929604663 },
        { lng: -0.14520596524977236, lat: 51.52397465429888 },
        { lng: -0.14512903667684895, lat: 51.52366952048803 },
        { lng: -0.1451963491783772, lat: 51.52343618148862 },
        { lng: -0.14556175990273346, lat: 51.52307719607751 },
        { lng: -0.1462252688475587, lat: 51.522903685447716 },
        { lng: -0.1468983938650581, lat: 51.52286180347269 },
        { lng: -0.14742772423588235, lat: 51.5230358995245 },
        { lng: -0.14798781744801204, lat: 51.52344014608536 },
        { lng: -0.1489959852301297, lat: 51.523258932553546 },
        { lng: -0.15237894823238207, lat: 51.52302195992377 },
        { lng: -0.15746459461053064, lat: 51.52207405506974 },
        { lng: -0.15699411631260318, lat: 51.52091702926225 },
        { lng: -0.1591224705189802, lat: 51.520554581396425 },
        { lng: -0.15961535254564296, lat: 51.52175343640465 },
        { lng: -0.16548513088633854, lat: 51.52063822461858 },
        { lng: -0.16591080172838701, lat: 51.51928599230121 },
        { lng: -0.16741185153645688, lat: 51.51808707233778 },
    ];

    const [map, setMap] = React.useState(null);


    React.useEffect(() => {
        if (origin && destination) {
            const directionsService =
                new window.google.maps.DirectionsService();

            directionsService.route(
                {
                    origin: origin.geometry.location,
                    destination: destination.geometry.location,
                    travelMode: "DRIVING", // You can change the travel mode as needed
                    drivingOptions: {
                        departureTime: new Date(Date.now()),
                        trafficModel: "pessimistic",
                    },
                    unitSystem: 1.0
                },
                (response, status) => {
                    if (status === "OK") {
                        setDirections(response);
                        // Retrieve distance and duration
                        const route = response.routes[0];
                        const legs = route.legs[0];

                        const distance = legs.distance.text;
                        const duration = legs.duration.text;

                        console.log("Distance:", distance);
                        console.log("Duration:", duration);
                        setDuration(duration);
                        setDistance(distance);
                    } else {
                        console.log(
                            "Directions request failed. Status:",
                            status
                        );
                    }
                }
            );
        }
    }, [origin, destination, setDistance, setDuration]);

    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instancelng! don't just blindly copy!
        // const bounds = new window.google.maps.LatLngBounds(center);
        // map.fitBounds(bounds);
        map.setZoom(10);

        setMap(map);
    }, []);

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null);
    }, []);

    const loadOriginMarker = () => {
        if (origin && origin.geometry && origin.geometry.location) {
            return (
                <Marker
                    position={{
                        lat: origin.geometry.location.lat,
                        lng: origin.geometry.location.lng,
                    }}
                />
            );
        } else {
            // Handle the case where `origin` or its properties are undefined
            return <></>; // Or render a placeholder or error message
        }
    };

    const locadDestinationMarker = () => {
        if (
            destination &&
            destination.geometry &&
            destination.geometry.location
        ) {
            return (
                <Marker
                    position={{
                        lat: destination.geometry.location.lat,
                        lng: destination.geometry.location.lng,
                    }}
                />
            );
        } else {
            // Handle the case where `origin` or its properties are undefined
            return <></>; // Or render a placeholder or error message
        }
    };

    return isLoaded ? (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            {/* Origin Marker */}
            {loadOriginMarker}
            {/* Destination Marker */}
            {locadDestinationMarker}
            <Polygon
                paths={congestionZoneCoordinates}
                options={{
                    fillColor: "#FF0000",
                    fillOpacity: 0.2,
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.5,
                    strokeWeight: 1,
                }}
            />
            {directions && (
                <DirectionsRenderer
                    directions={directions}
                    options={{
                        polylineOptions: {
                            strokeColor: "#0000FF",
                            strokeOpacity: 0.7,
                            strokeWeight: 5,
                        },
                    }}
                />
            )}
        </GoogleMap>
    ) : (
        <></>
    );
}

export default React.memo(MapsComponent);
